import { SidebarMenuButton, useSidebar } from "@ui/components/ui/sidebar";
import { forwardRef, type ForwardedRef, type ReactNode } from "react";
import { NavLink, useMatch } from "react-router";
import { cn, type ButtonProps } from "ui";

function useSidebarIdMatch() {
  return useMatch("/:sidebarId?/:subId?");
}

export interface NavButtonProps {
  icon: ReactNode;
  text: string;
  href: string;
  className?: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  activeWhen?: (match: ReturnType<typeof useMatch>) => boolean;
}

export const NavButtonV2 = forwardRef(function NavButtonV2(
  { href, activeWhen, className, ...props }: NavButtonProps,
  ref: ForwardedRef<HTMLAnchorElement>,
) {
  const sidebar = useSidebar();

  const match = useSidebarIdMatch();
  const isActive = activeWhen ? activeWhen(match) : false;

  return (
    <SidebarMenuButton asChild isActive={isActive}>
      <NavLink
        to={href}
        {...props}
        ref={ref}
        onClick={() => {
          sidebar.setOpenMobile(false);
        }}
        className={cn(className, {
          active: isActive,
        })}
      >
        {props.icon}
        <span className="">{props.text}</span>
      </NavLink>
    </SidebarMenuButton>
  );
});
